// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FieldsFixed_wrapper__u4fhs","fixed":"FieldsFixed_fixed__1aWM2","label":"FieldsFixed_label__T8orz","value":"FieldsFixed_value__1N4zr"};